import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateWorkOrderObjectGql } from '../../workOrderQueries';

const requestId = 'uerUpdateWorkOrderObject';

export const useUerUpdateWorkOrderObject = (workOrderId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [uerUpdateWorkOrderObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerUpdateWorkOrderObjectReset(undefined);
        onSuccess?.();
    }, [uerUpdateWorkOrderObjectReset, onSuccess]);

    const [
        uerUpdateWorkOrderObjectData,
        uerUpdateWorkOrderObjectStatus,
        uerUpdateWorkOrderObjectError,
        uerUpdateWorkOrderObjectRequest,
    ] = useRequest({
        requestId,
        query: uerUpdateWorkOrderObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerUpdateWorkOrderObjectMakeRequest = useCallback(
        (input: ContractObjectUpdateInput) => {
            dispatch(uerUpdateWorkOrderObjectRequest({ workOrderId, input }));
        },
        [uerUpdateWorkOrderObjectRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        uerUpdateWorkOrderObjectReset(undefined);
    }, [uerUpdateWorkOrderObjectReset]);

    return {
        uerUpdateWorkOrderObjectData,
        uerUpdateWorkOrderObjectStatus,
        uerUpdateWorkOrderObjectError,
        uerUpdateWorkOrderObjectMakeRequest,
    };
};
